import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus",
  "use": "plus-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus\">\n<line x1=\"16.9004\" y1=\"1.30664\" x2=\"16.9004\" y2=\"32.3066\" stroke=\"black\" stroke-linecap=\"round\" />\n<line x1=\"0.800781\" y1=\"16.4058\" x2=\"31.8008\" y2=\"16.4058\" stroke=\"black\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol